import React, { useState } from 'react';

import cn from 'classnames';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import Router from 'next/router';

import { SpotTradeAPI } from '@api/spotTrade';
import CollectEmpty from '@components/CollectEmpty';
import { Icon } from '@components/index';
import WebsocketKline from '@components/WebsocketKline';
import { TabPane, Tabs } from '@element/index';
import useAuthSession from '@lib/hooks/useAuthSession';
import useClient from '@lib/hooks/useClient';
import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect';
import helper from '@utils/helper';
import I18n from '@utils/i18n';
import { getLoginPath } from '@utils/index';
import { getListData, handleZoneList } from '@widget/market/TradeList/utils';
import { useMain } from '@widget/trade';

import List from '../TradeList/List';
import { DrawerBtn } from './DrawerBtn';

import styles from './index.module.less';

function T (props) {
  const {
    marketStore = {},
    tabsJump,
    tradeStore,
    tradeStore: {
      favoriteObject: { symbols = [], zones = [] },
      fetchFavoriteList,
      fetchFavoriteSort
    },
    setDrawerVisible = () => {}
  } = props;
  const isPc = useClient();
  const isLogin = useAuthSession({ redirectTo: null });
  const [loading, setLoading] = useState(false);
  const [zonesMarketList, setZonesMarketList] = useState([]);
  const [activeKey, setActiveKey] = useState('1');
  const [enteredOptional, setEnteredOptional] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [deleteRowKeys, setDeleteRowKeys] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const data = getListData('ALL', marketStore, {
    listType: 'favoriteList',
    enteredOptional,
    isLogin
  });

  useIsomorphicLayoutEffect(() => {
    setEnteredOptional(localStorage.getItem('enteredOptional'));
    // enteredOptional === null , 首次进入
    // enteredOptional ！== null，则非首次进入
    return () => setShowEdit(false);
  }, []);

  useIsomorphicLayoutEffect(() => {
    if (showEdit) {
      setDataSource(data);
    }
  }, [showEdit]);

  const tabChange = async (activeKey) => {
    setActiveKey(activeKey);
    setShowEdit(false);
    if (activeKey !== '1') {
      setLoading(true);
      const response = await SpotTradeAPI.getZoneDetail({
        key: activeKey,
        currency: 'USDT'
      });
      if (response && response.success && response.obj) {
        const dataList = handleZoneList({
          dataList: response.obj?.tickerList ?? [],
          marketStore,
          favoriteSymbols: symbols
        });
        setZonesMarketList(dataList);
        setLoading(false);
      } else {
        helper.handleErrorMsg(response?.msgKey);
      }
    }
  };

  const selecteChange = (rowKeys) => {
    setSelectedRowKeys(rowKeys);
  };

  const selectAll = () => {
    if (selectedRowKeys.length === symbols.length) {
      // 反选
      selecteChange([]);
      return;
    }
    const keys = symbols.map((i) => i.symbol);
    const rows = symbols.map((i) => toJS(i));
    selecteChange(keys, rows);
  };

  const cancelHandle = () => {
    setShowEdit(false);
    selecteChange([], []);
    setDeleteRowKeys([]);
  };

  const deleteRows = () => {
    const selectKeyMap = selectedRowKeys.reduce((prev, curr) => {
      prev[curr] = curr;
      return prev;
    }, {});

    const data = dataSource.filter((i) => {
      return !selectKeyMap[i.coinCode];
    });
    setDeleteRowKeys([...deleteRowKeys, ...selectedRowKeys]);
    setDataSource(data);
  };

  const submitHandle = async () => {
    const deleteKeysMap = deleteRowKeys.reduce((prev, curr) => {
      prev[curr] = -1;
      return prev;
    }, {});
    const sortListMap = dataSource.reduce((prev, curr, index) => {
      prev[curr.coinCode] = index + 1;
      return prev;
    }, {});
    const changes = { ...deleteKeysMap, ...sortListMap };
    await fetchFavoriteSort({
      changes: encodeURIComponent(JSON.stringify(changes)),
      favorite_type: 'symbol'
    });
    fetchFavoriteList();
    setDeleteRowKeys([]);
    setShowEdit(false);
  };

  const onTopping = (coinCode) => {
    const _data = [...dataSource];
    const topppingIndex = _data.findIndex((i) => i.coinCode === coinCode);
    const topppingItem = _data.splice(topppingIndex, 1)[0];
    topppingItem.top = true;
    _data.splice(0, 0, topppingItem);
    setDataSource(_data);
  };

  const oneKeyFavoriteAdd = async () => {
    if (!isLogin) {
      Router.push(getLoginPath());
      return;
    }
    await tradeStore.fetchFavoriteAdd({
      items: marketStore.recommendList.map((item) => item.symbol).join(','),
      favorite_type: 'symbol'
    });
    fetchFavoriteList();
    setEnteredOptional('true');
    localStorage.setItem('enteredOptional', 'true');
  };

  const favoriteAdd = () => {
    if (!isLogin) {
      Router.push(getLoginPath());
      return;
    }
    tabsJump('1');
    setEnteredOptional('true');
    localStorage.setItem('enteredOptional', 'true');
  };
  const params = useMain({ marketStore, tradeStore });
  const { onWebSocketReady } = params;
  const isRecommendList = !isLogin || (!symbols?.length && !enteredOptional); // 未登录 || 第一次进来，并且没有收藏，并且有推荐列表 ，此条件展示推荐list
  return (
    <div className={styles.optionalContainer}>
      {!showEdit ? <WebsocketKline onReady={onWebSocketReady} /> : null}
      <Tabs
      className={cn(styles.tabsClass, 'pairTrading')}
        type="marketTabCoin"
        tabBarExtraContent={
          isLogin && (
            <div
              className={cn(styles.exitOptional, {
                [styles.hide]: showEdit,
                [styles.grey]: activeKey !== '1' || isRecommendList
              })}
              onClick={() => {
                if (activeKey !== '1' || isRecommendList) return;
                setShowEdit(!showEdit);
              }}
            >
              {isPc && I18n.t('8qtB0Y7f')}
              <Icon name="editBoxLine" className={styles.iconSize} />
            </div>
          )
        }
        onChange={tabChange}
      >
        <TabPane
          tab={<h3 className="DINPro">{I18n.t('symbol_list')}</h3>}
          key={1}
          type="marketTabCoin"
          className={styles.mt12}
        >
          <List
            dataSource={showEdit ? dataSource : data}
            setDataSource={setDataSource}
            selecteChange={selecteChange}
            onTopping={onTopping}
            selectedRowKeys={selectedRowKeys}
            isEdit={showEdit}
            emptyText={<CollectEmpty />}
            hideCoinIcon={!isPc && !showEdit}
            isRecommendList={isRecommendList}
            setDrawerVisible={setDrawerVisible}
          />
        </TabPane>
        {zones.map((zonesItem) => (
          <TabPane
            tab={I18n.t('zoneName' + zonesItem.categoryKey.toUpperCase())}
            type="marketTabCoin"
            key={zonesItem.categoryKey}
          >
            <List
              page="ZONES_PAGE"
              loading={loading}
              dataSource={zonesMarketList}
              marketStore={props.marketStore}
              setDrawerVisible={setDrawerVisible}
            />
          </TabPane>
        ))}
      </Tabs>
      <div className={styles.addBtnContainer}>
        <div
          className={cn(styles.oneKeyAdd, styles.hide, {
            [styles.showOneKeyAdd]: activeKey === '1' && isRecommendList
          })}
          onClick={oneKeyFavoriteAdd}
        >
          {I18n.t('mt3QNJK6')}
        </div>
        <div
          className={cn(styles.addOptioanal, {
            [styles.addOptioanal_Advanced]: !isRecommendList,
            [styles.hide]:
              showEdit || activeKey !== '1' || (isLogin && !symbols?.length)
          })}
          onClick={favoriteAdd}
        >
          {!isRecommendList && (
            <Icon name="plusSign" className={styles.plusSignIcon} />
          )}
          {I18n.t('AQg7qZVz')}
        </div>
      </div>
      <DrawerBtn
        isPc={isPc}
        selectedRowKeys={selectedRowKeys}
        deleteRows={deleteRows}
        submitHandle={submitHandle}
        cancelHandle={cancelHandle}
        selectAll={selectAll}
        showEdit={showEdit}
      />
    </div>
  );
}
export const OptionalList = inject((rootStore) => ({
  userStore: rootStore.store.userStore,
  tradeStore: rootStore.store.tradeStore,
  marketStore: rootStore.store.marketStore
}))(observer(T));
